import { ClearableTextField } from '@app/components/form/ClearableTextField';
import { Grid } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { AuditDateTimeRangeFields } from '../../../../components/AuditDateTimeRangeFields';
import { CustomIdField } from '../../../../components/CustomIdField';

const orderFieldMessage = defineMessage({
  id: 'audit.props.order',
  defaultMessage: 'Orden',
});

const versionFieldMessage = defineMessage({
  id: 'audit.props.version',
  defaultMessage: 'Versión',
});

export function SpotMatchesForm() {
  const { $t } = useIntl();

  return (
    <div>
      <AuditDateTimeRangeFields />
      <Grid container spacing={2}>
        <Grid item xs={12} md={4} lg={3} xl={2}>
          <CustomIdField />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <ClearableTextField name="order" submitOnClear label={$t(orderFieldMessage)} />
        </Grid>
        <Grid item xs={12} md={4} lg={2}>
          <ClearableTextField name="version" submitOnClear label={$t(versionFieldMessage)} />
        </Grid>
      </Grid>
    </div>
  );
}
